import { fetchAuthSession } from 'aws-amplify/auth';

const API_ENDPOINT = `${import.meta.env.VITE_API_BASE_URL}/adminupdateuserattributes`;

export const updateCognitoUserAttributes = async (props) => {
  const { username, attributes } = props;

  const params = {
    Username: username,
    UserAttributes: attributes,
  };

  const session = await fetchAuthSession();
  const authToken = `Bearer ${session.tokens.idToken}`;

  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': authToken,
    },
    body: JSON.stringify(params),
  });

  // Read the body once as text so we can surface it whether or not it's JSON
  // (a gateway 403, for example, returns a plain { "message": ... } object).
  const raw = await response.text();
  let data;
  try {
    data = raw ? JSON.parse(raw) : null;
  } catch {
    data = raw; // non-JSON body — keep the string for the error message
  }

  // 1) Any non-2xx HTTP status is a hard failure. This is what was silently
  //    swallowed before: a 403 from the authorizer resolved as if it succeeded,
  //    so custom:teamMemberId never got written and nothing logged.
  if (!response.ok) {
    const detail =
      (data && typeof data === 'object' && (data.message || data.errorMessage)) ||
      (typeof data === 'string' && data) ||
      response.statusText;
    throw new Error(`updateCognitoUserAttributes failed (HTTP ${response.status}): ${detail}`);
  }

  // 2) Some routes return a 200 envelope that wraps a non-2xx ({ statusCode, body }).
  //    Treat that as a failure too, so a wrapped error can't slip through.
  if (data && typeof data === 'object' && typeof data.statusCode === 'number' && data.statusCode >= 400) {
    let inner = data.body;
    if (typeof inner === 'string') {
      try { inner = JSON.parse(inner); } catch { /* leave as string */ }
    }
    const detail =
      (inner && typeof inner === 'object' && (inner.errorMessage || inner.message)) ||
      (typeof inner === 'string' && inner) ||
      JSON.stringify(inner);
    throw new Error(`updateCognitoUserAttributes failed (status ${data.statusCode}): ${detail}`);
  }

  return data;
};
